import React from 'react';
import PropTypes from 'prop-types';

import { Button } from '../../ui';

/**
 * Link-styled button, all caps, underlined, small
 */
export const EducationModalCTAButton = props => (
  <Button
    appearance="primary"
    size="large"
    style={{
      fontSize: 15,
      padding: '0 32px',
    }}
    {...props}
  >
    {props.children}
  </Button>
);
EducationModalCTAButton.propTypes = {
  children: PropTypes.node,
};
EducationModalCTAButton.defaultProps = {
  children: null,
};
export default EducationModalCTAButton;
